import { render, staticRenderFns } from "./wenjuan.vue?vue&type=template&id=54b0fac9"
import script from "./wenjuan.vue?vue&type=script&lang=js"
export * from "./wenjuan.vue?vue&type=script&lang=js"
import style0 from "./wenjuan.vue?vue&type=style&index=0&id=54b0fac9&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports